import {
  FORM_ADD_PAYTO_MAX_AMOUNT_NAME,
  FORM_ADD_PAYTO_PAYID_TYPE_NAME,
  PAYTO_LOG_TAG,
  RESET_FORM_ADD_PAYTO_ACCOUNT_STORE,
} from 'features/to/const';
import usePaytoStore from 'features/to/hooks/payment/usePaytoStore';
import { isEmpty } from 'lodash';
import React, { useEffect, useState } from 'react';
import withRoundUpPaytoMaxAmount from './withRoundUpPaytoMaxAmount';

const withAddPaytoAccountManual = (Component) => {
  const AddPaytoAccountManualComponent = withRoundUpPaytoMaxAmount((props) => {
    const {
      setAddManual,
      setAddPayIdManual,
      paytoAccountInformationRetry,
      setPaytoAccountValidation,
      maxAmountInitialVer2,
    } = props || {};

    const { setPaytoAccountInformation, setPaytoPayIdBankValidationFailure } =
      usePaytoStore();

    const [bsbNumberMaskStr, setBsbNumberMaskStr] = useState('');
    const [accountNumberMaskStr, setAccountNumberMaskStr] = useState('');

    useEffect(() => {
      if (!isEmpty(paytoAccountInformationRetry)) return;
      setBsbNumberMaskStr('');
      setAccountNumberMaskStr('');
    }, [paytoAccountInformationRetry]);

    const handleUseOtherPaytoAccountOnSelect = () => {
      const payload = {
        ...RESET_FORM_ADD_PAYTO_ACCOUNT_STORE,
        [FORM_ADD_PAYTO_MAX_AMOUNT_NAME]: `${maxAmountInitialVer2}`,
        id: 'other',
      };
      console.log(
        `⭐ ${PAYTO_LOG_TAG} 👉 handleUseOtherPaytoAccountOnSelect ➡️ payload ↩`,
        payload
      );
      setPaytoAccountInformation(payload);

      let newValidation = { ...RESET_FORM_ADD_PAYTO_ACCOUNT_STORE };
      delete newValidation?.[FORM_ADD_PAYTO_PAYID_TYPE_NAME];
      setPaytoAccountValidation(newValidation);

      // DEV-1401: symmetric with withAddPaytoPayIdAccountManual.jsx -- close
      // the same staleness path in this direction too.
      setPaytoPayIdBankValidationFailure(false);

      setAddPayIdManual(false);
      setAddManual(true);
    };

    const newProps = {
      ...props,
      bsbNumberMaskStr,
      setBsbNumberMaskStr,
      accountNumberMaskStr,
      setAccountNumberMaskStr,
    };
    return (
      <Component {...newProps} onSelect={handleUseOtherPaytoAccountOnSelect} />
    );
  });
  return AddPaytoAccountManualComponent;
};

export default withAddPaytoAccountManual;
